var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 14.317,
    height: 23,
    viewBox: "0 0 14.317 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_53276",
    "data-name": "Rectangle 53276",
    width: 14.317,
    height: 23,
    fill: "#80838e"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_146953",
    "data-name": "Group 146953",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50320",
    "data-name": "Path 50320",
    d: "M12.8,0H3.252A2.427,2.427,0,0,0,1.569.672a2.254,2.254,0,0,0-.7,1.623V20.7a2.224,2.224,0,0,0,.181.879,2.293,2.293,0,0,0,.516.745,2.389,2.389,0,0,0,.773.5A2.461,2.461,0,0,0,3.252,23H12.8a2.429,2.429,0,0,0,1.684-.672,2.255,2.255,0,0,0,.7-1.623V2.295A2.223,2.223,0,0,0,15,1.416a2.292,2.292,0,0,0-.517-.745,2.389,2.389,0,0,0-.773-.5A2.459,2.459,0,0,0,12.8,0ZM8.03,21.85a1.4,1.4,0,0,1-.989-.282,1.306,1.306,0,0,1-.5-.868,1.306,1.306,0,0,1,.5-.868,1.4,1.4,0,0,1,.989-.282,1.4,1.4,0,0,1,.989.282,1.306,1.306,0,0,1,.5.868,1.306,1.306,0,0,1-.5.868,1.4,1.4,0,0,1-.989.282ZM12.8,18.4H3.258V2.3H12.8Z",
    transform: "translate(-0.871)",
    fill: "#80838e"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobile);
export default __webpack_public_path__ + "static/media/mobile.644a69b07a762724858af66062ed91df.svg";
export { ForwardRef as ReactComponent };